import { ITotals } from '@checkout/items';
import { IShippingMethod, ISteps, RootState } from '@checkout/state';
import * as React from 'react';
import { ChangeEvent } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import { shippingMethodChangeRequest } from '../../../reducers/checkout';
import { MessageBox, RadioGroup } from '../../presentational';
import * as Styles from './DeliveryOptions.scss';

interface IOwnProps {
  readOnly?: boolean;
  showButton?: boolean;
}

interface IConnectedProps {
  steps: ISteps;
  shippingMethods: IShippingMethod[];
  totals: ITotals;
  selectedShippingMethod: string;
  selectedShippingMethodName: string;
}

interface IConnectetDispatchProps {
  shippingMethodChangeRequest: typeof shippingMethodChangeRequest;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class DeliveryOptions extends React.Component<Props, {}> {

  handleDeliveryOptionChange = (event: ChangeEvent<any>) => {
    this.props.shippingMethodChangeRequest({ shippingMethod: event.target.value });
  }

  render() {
    const { readOnly, selectedShippingMethod, shippingMethods, selectedShippingMethodName, totals } = this.props;

    return (
      <div>
        {readOnly && totals && (
          <div className={Styles.readOnly}>
            <span className={Styles.shippingName}>{selectedShippingMethodName}</span>
            <span className={Styles.shippingPrice}>{totals.shippingPrice}</span>
          </div>
        )}
        {!readOnly && (
          <RadioGroup
            blockFor="ShippingMethods"
            options={shippingMethods}
            selectedOption={selectedShippingMethod}
            groupName="shippingMethod"
            onChange={this.handleDeliveryOptionChange}
          />
        )}
        <CheckoutContextConfig.Consumer>
          {(checkoutContextConfig => (
            checkoutContextConfig.ui.shippingMethodDescriptions &&
            checkoutContextConfig.ui.shippingMethodDescriptions.enabled &&
            checkoutContextConfig.ui.shippingMethodDescriptions.descriptions[selectedShippingMethod] && (
              <MessageBox
                type="info"
                spacingTop={true}
                message={checkoutContextConfig.ui.shippingMethodDescriptions.descriptions[selectedShippingMethod]}
              />
            )
          ))}
        </CheckoutContextConfig.Consumer>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  steps: state.checkout.steps,
  shippingMethods: state.checkout.shippingMethods,
  totals: state.checkout.selection.totals,
  selectedShippingMethodName: state.checkout.selection.shippingMethodName,
  selectedShippingMethod: state.checkout.selection.shippingMethod
});

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    mapStateToProps,
    {
      shippingMethodChangeRequest
    },
  )
)(DeliveryOptions);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/DeliveryOptions/DeliveryOptions.tsx